/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\r\n.drag-border{border:2px dashed #ff525b}.drag-handle{cursor:move; cursor:grab;cursor:-webkit-grab}.drag-handle:active{cursor:grabbing;cursor:-webkit-grabbing}\r\n\r\n.drag-hint-border{border:2px dashed #3c763d}.drag-over-border{border:2px dashed #fbbc05}.drag-transit{border:2px dashed #3500ff}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/ng-drag-drop/style.css.ngstyle.js.pre-build-optimizer.js